import segurosReducer from './listaReducer';



export default {
segurosReducer 
}

